import React from "react";

const Projects = () => {
  return (
    <>
      <div className="row gx-0 text-center px-md-5 pt-5" id="targetProject">
        <h1 className="mb-3"> Recent Projects </h1>
        <div className="col-12">
          <div className="col-md-8 m-auto">
            <p className="mx-md-5 px-md-5 px-2 py-3">
              <small>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Accusantium ratione inventore quod et debitis maiores quaerat
                suscipit minima. Dolor quidem velit.
              </small>
            </p>
          </div>
        </div>

        <div className="col-md-4 col-6 p-md-3 p-2">
          <div className="projectCard" id="project1">
            <div className="w-100 h-100">
              <div>
                <h4 className="fw-normal"> It's a food ordering project</h4>
                <p className="mb-4 mt-3">
                <small>For : Web & APP</small>
                </p>
                <a
                  href="https://caferio.herokuapp.com/"
                  rel="noreferrer"
                  className="navBtnLinks py-2"
                  target={"_blank"}
                >
                  See Project
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-6 p-md-3 p-2">
          <div className="projectCard" id="project2">
            <div className="w-100 h-100">
              <div>
                <h4 className="fw-normal"> It's an NGO project</h4>
                <p className="mb-md-4 mt-md-3">
                <small>For : Web & APP</small>
                </p>
                <a
                  href="https://panah.netlify.app/"
                  rel="noreferrer"
                  className="navBtnLinks py-2"
                  target={"_blank"}
                >
                  See Project
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-6 p-md-3 p-2">
          <div className="projectCard" id="project3">
            <div className="w-100 h-100">
              <div>
                <h4 className="fw-normal"> It's an e-commerce project </h4>
                <p className="mb-4 mt-3">
                <small>For : Web & APP</small>
                </p>
                <a
                  href="https://grani.herokuapp.com/"
                  rel="noreferrer"
                  className="navBtnLinks py-2"
                  target={"_blank"}
                >
                  See Project
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-6 p-md-3 p-2">
          <div className="projectCard" id="project4">
            <div className="w-100 h-100">
              <div>
                <h4 className="fw-normal"> It's a covid tracker project </h4>
                <p className="mb-4 mt-3">
                <small> Under Process </small>
                </p>
                <a
                  href="https://covid19byreact.netlify.app/"
                  rel="noreferrer"
                  className="navBtnLinks py-2"
                  target={"_blank"}
                >
                  See Project
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-6 p-md-3 p-2">
          <div className="projectCard" id="project5">
            <div className="w-100 h-100">
              <div>
                <h4 className="fw-normal"> It's a consultants project </h4>
                <p className="mb-4 mt-3">
                <small>For : Web & APP</small>
                </p>
                <a
                  href="https://shbpvtltd.netlify.app/"
                  rel="noreferrer"
                  className="navBtnLinks py-2"
                  target={"_blank"}
                >
                  See Project
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-6 p-md-3 p-2">
          <div className="projectCard" id="project6">
            <div className="w-100 h-100">
              <div>
                <h4 className="fw-normal"> It's an institute project </h4>
                <p className="mb-4 mt-3">
                <small>For : Web & APP</small>
                </p>
                <a
                  href="https://newvsit.netlify.app/"
                  rel="noreferrer"
                  className="navBtnLinks py-2"
                  target={"_blank"}
                >
                  See Project
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
